<template>
    <v-row>
        <v-col cols="12">
            <div class="ob-title">
                {{ $t('entrance.equipment_available') }}
            </div>
        </v-col>
        <v-col cols="12">
            <v-row dense>
                <v-col v-for="(item, i) in equipmentOptions" :key="i" cols="4">
                    <div
                        class="equip-item"
                        :class="{ selected: isSelected(item) }"
                        @click="toggle(item)"
                    >
                        <v-img :src="item.src" height="36" width="36" contain class="equip-icon"/>
                        <span class="equip-label">{{ item.name }}</span>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>

import {mapActions, mapState} from 'vuex'

export default {
    data() {
        return {
            equipmentsArray: [],
        }
    },
    computed: {
        ...mapState(['equipment']),
        equipmentOptions(vm = this) {
            if (vm.equipment.length === 0) return []
            return vm.equipment.map(equip => ({name: equip.name, value: equip.name, src: equip.src}))
        }
    },
    async mounted() {
        const vm = this
        if (vm.equipment.length === 0) await vm.bindEquipment()
        vm.loadEquipments()
    },
    methods: {
        ...mapActions(['bindEquipment']),
        loadEquipments() {
            const vm = this
            vm.equipmentsArray = [...(vm.account?.equipments || [])]
        },
        isSelected(item) {
            return this.equipmentsArray.includes(item.value)
        },
        toggle(item) {
            const vm = this
            const index = vm.equipmentsArray.indexOf(item.value)
            if (index === -1) vm.equipmentsArray.push(item.value)
            else vm.equipmentsArray.splice(index, 1)
        }
    },
    watch: {
        account() {
            this.loadEquipments()
        },
        equipmentsArray(val) {
            this.$emit('change', val)
        },
    },
}
</script>

<style scoped>

.ob-title {
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.equip-item {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 14px;
    border-radius: 10px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface-base);
    cursor: pointer;
    transition: border-color .15s ease, background-color .15s ease, color .15s ease;
    text-align: center;
}

.equip-item.selected {
    border-color: var(--v-secondary-base);
    background: rgba(102, 204, 204, 0.08);
    color: var(--v-accent-base);
}

.equip-icon {
    flex: 0 0 auto;
}

.equip-label {
    font-size: 13px;
    font-weight: 500;
}

</style>
